/**
 * Get a cookie value by name
 */
const getCookie = (name: string): string | null => {
  if (typeof document === "undefined") {
    return null;
  }
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(";").shift();
    return cookieValue || null;
  }
  return null;
};

/**
 * Check if the user is logged in
 * Uses the "loggedIn" cookie to check authentication status
 */
export const isLoggedIn = (): boolean => {
  const loggedInCookie = getCookie("loggedIn");
  return loggedInCookie === "true";
};
